




































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Button, Icon, Dialog, Field, Toast } from "vant";
import NetErrorPage from "@/components/NetErrorPage.vue";
import { jumpLink } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
const browser = getBrowser();

import moment from "moment";

const failReasonModule = namespace("failReason");
const createAccountModule = namespace("createAccount");

Component.registerHooks(["beforeRouteEnter"]);
@Component({
  name: "FailReason",
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    NetErrorPage: NetErrorPage,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field
  }
})
export default class FailReason extends Vue {
  @failReasonModule.Getter("modified_reason_list") modified_reason_list: any;
  @failReasonModule.Mutation("CLEAR_MODIFIED_FAIL_REASON")
  clearModifiedFailReason: any;
  @createAccountModule.Mutation("SAVE_OPEN_MODE_INFO") saveOpenModeInfo: any;
  @createAccountModule.Mutation("SAVE_ID_CARD_PHOTO") saveIdCardPhoto: any;
  @createAccountModule.Mutation("SAVE_ID_CARD_OCR_INFO") saveIdCardOcrInfo: any;
  @createAccountModule.Mutation("SAVE_ADDRESS_PROOF_INFO")
  saveAddressProofInfo: any;

  @createAccountModule.Mutation("SAVE_TAX_PLACE") saveTaxPlace: any;
  @createAccountModule.Mutation("SAVE_W8BEN_INFO") saveW8benInfo: any;
  @createAccountModule.Mutation("SAVE_DERIVATIVE") saveDerivative: any;

  showPage = false;
  AllFailReasonList: any = [];
  currentFailReasonList: any = [];
  is_verify = 0;

  isLoading = true;
  requestFail = true;

  is_account = 1;

  error_type: string = "";

  checkPassword: string = ""; // 校验登录密码
  checkPasswordShow: boolean = false; // 显示弹出框

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  get isDisabledSubmit() {
    const res = this.currentFailReasonList.some(item => {
      return item.status == 0;
    });
    return res || this.is_verify == 0 || this.is_verify == 2;
  }

  created() {
    this.getopeninfo();
    this.AllFailReasonList = this.$t("fail_reason.fail_reason_list");
    this.getOpenAccountInfo();
  }

  activated() {
    if (this.currentFailReasonList.length) {
      this.currentFailReasonList.map(item => {
        
        if (this.modified_reason_list.includes(item.id)) {
          item.status = 1;
        }
      });
    }
  }

  getopeninfo() {
    (this as any).$apis.getOpenInfo().then(res => {
      this.is_account = res.open_method;
    });
  }

  getOpenAccountInfo() {
    this.isLoading = true;
    (this as any).$apis
      .getOpenAccountInfo()
      .then(res => {
        const {
          birth,
          detail_address,
          country_name,
          country_code,
          city_name,
          city_code,
          province_name,
          province_code,
          real_name,
          english_name,
          id_card,
          sex,
          open_status,
          address,
          address_img,
          positive_img,
          inverse_img,
          info_extend: { tax_place, w_ben_content, cognition_derivatives },
          nationality_name,
          nationality_code
        } = res;
        this.saveTaxPlace(tax_place);
        this.saveIdCardOcrInfo({
          birth: birth ? moment(birth).format("YYYY-MM-DD") : "",
          detail_address,
          country_name,
          country_code,
          city_name,
          city_code,
          province_name,
          province_code,
          real_name,
          english_name,
          id_card,
          sex,
          nationality_code,
          nationality_name
        });
        this.saveOpenModeInfo({ open_status });
        this.saveDerivative(cognition_derivatives.derivative);
        this.saveIdCardPhoto({ positive_img, inverse_img });
        this.saveW8benInfo(w_ben_content);
        this.saveAddressProofInfo({ address, address_img });
        this.handleGetFailReasonCreateAccount();
      })
      .catch(e => {
        this.requestFail = true;
        this.isLoading = false;
      });
  }

  handleGetFailReasonCreateAccount() {
    (this as any).$apis
      .getFailReasonCreateAccount()
      .then(res => {
        this.requestFail = false;
        const { is_verify, pass_reason } = res;
        this.is_verify = is_verify;
        const list = pass_reason ? pass_reason.split(",") : [];
        this.error_type = pass_reason;
        this.currentFailReasonList = list.map(item => {
          //当状态为待审核或者通过时, 失败原因的status设置为已处理
          if (this.is_verify == 0 || this.is_verify == 2) {
            return {
              ...this.AllFailReasonList[item - 1],
              status: 1
            };
          } else {
            this.clearModifiedFailReason();
            return this.AllFailReasonList[item - 1];
          }
        });
      })
      .catch(e => {
        this.requestFail = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  handleReasonItemClick(item) {
    if (item.status) return;
    this.$router.push({
      path: item.path,
      query: {
        modify: "1",
        type: "2"
      }
    });
  }

  beforeClose(action, done) {
    done(false);
  }
  handModifiy(){
	  // (this as any).$apis.getAccountSituation().then(res =>{
	  // 			  // hb_account_status  证券  hk_account_status 环球
	  // 		if(res.hb_account_status === 0 && res.hk_account_status === 0){
	  // 			this.handleNextStep();
	  // 	    }else{
			// 	this.checkPasswordShow = true  
			// }
	  			  
	  // })
	  this.handleNextStep();
  }
  
  
  

  confirm() {
    if (this.checkPassword === "") {
      Toast(this.$t("fail_reason.checkPasswordTips"));
    } else {
      (this as any).$apis
        .checkPasswordFail({
          password: this.checkPassword
        })
        .then((res: any) => {
          this.checkPasswordShow = false;
          this.handleNextStep();
        });
    }
  }

  handleNextStep() {
    if (this.is_verify == 0 || this.is_verify == 2) return;
    (this as any).$apis.submitUserInfoModify().then(() => {
      if (browser.isApp) {
        jumpLink("refresh_user");
      } else {
        this.$router.push("/");
      }
    });
  }

  handNext() {
    if (browser.isApp) {
      jumpLink("refresh_user");
    } else {
      this.$router.push("/");
    }
  }
}
